import { render, staticRenderFns } from "./CardButtons.vue?vue&type=template&id=dc29d550&scoped=true&"
import script from "./CardButtons.vue?vue&type=script&lang=js&"
export * from "./CardButtons.vue?vue&type=script&lang=js&"
import style0 from "./CardButtons.vue?vue&type=style&index=0&id=dc29d550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc29d550",
  null
  
)

export default component.exports